import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_8.module.css";
import Head from "next/head";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter8.json";


export default function Chapter_8() {

  // const corosalref = useRef()

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start"
  //     })
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>The ultimate reconciliation of direct experience | School of Our Divine Infinite Being</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        <meta name="keywords" content="Divine Infinite Being, Central Doctrine, Chapter-VIII"></meta>
        <meta property="og:title" content="The ultimate reconciliation of direct experience | School of Our Divine Infinite Being"></meta>
        <meta property="og:type" content="website" ></meta>
        <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter8_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="og:image:alt" content="Image of two hands reaching out and connecting across a cosmic landscape, symbolizing the reconciliation of personal spiritual experiences. The scene is bathed in soft, harmonious light, with waves of energy and sacred symbols converging to represent the unity of diverse spiritual paths within the Divine Infinite Being's doctrine."></meta>
        <meta property="og:description" content="The Platonic Theurgic opposition, the Diad, is the Unlimited and the Limited in its duality."></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta property="og:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=7"></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter8_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Image of two hands reaching out and connecting across a cosmic landscape, symbolizing the reconciliation of personal spiritual experiences. The scene is bathed in soft, harmonious light, with waves of energy and sacred symbols converging to represent the unity of diverse spiritual paths within the Divine Infinite Being's doctrine."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=7"></meta>
        <meta name="twitter:title" content="The ultimate reconciliation of direct experience | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="The Platonic Theurgic opposition, the Diad, is the Unlimited and the Limited in its duality."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=8" />
      </Head>


      <Common_html BlockData={BlockData} />
      
    </>
  );
}
